import notifications from "@evercam/shared/plugins/notifications"
import { defineNuxtPlugin } from "#app"

export default defineNuxtPlugin(notifications)
